import { ComponentMoleculesTabMenuPanel } from "types/graphql/generated";

export const isAllowedToShowMobileCta = (activeTabResource: ComponentMoleculesTabMenuPanel): boolean => {
  // Hardcoded for now, should be replaced with a more dynamic solution
  return !activeTabResource?.linkedPanels?.some((panel) => {
    const billboardPrimaryButtonUrl = panel?.featureListWithBillboard?.billboard?.primaryButton?.url;

    return billboardPrimaryButtonUrl?.includes("gfa-pipeline");
  });
};
